/* unplugin-vue-components disabled */import { render } from "./scraping.vue?vue&type=template&id=16e42949&scoped=true"
import script from "./scraping.vue?vue&type=script&lang=js"
export * from "./scraping.vue?vue&type=script&lang=js"

import "./scraping.vue?vue&type=style&index=0&id=16e42949&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e42949"],['__file',"src/pages/settings/admin/scraping.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16e42949"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16e42949', __exports__)) {
    api.reload('16e42949', __exports__)
  }
  
  module.hot.accept("./scraping.vue?vue&type=template&id=16e42949&scoped=true", () => {
    api.rerender('16e42949', render)
  })

}


export default __exports__